import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Home from "@/pages/Home";
import AdminPage from "@/pages/AdminPage";
import AccountPage from "@/pages/AccountPage";
import PartnerPage from "@/pages/PartnerPage";
import DriverPage from "@/pages/DriverPage";
import LegalPage, { CookieBanner } from "@/pages/LegalPage";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

const LenisContext = React.createContext(null);
export const useLenis = () => useContext(LenisContext);

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 text-center">
          <div>
            <p className="font-bold text-fr-navy">Si è verificato un errore.</p>
            <button className="mt-3 text-sm underline" onClick={() => window.location.reload()}>
              Ricarica
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const LenisProvider = ({ children }) => {
  const [lenis, setLenis] = useState(null);
  useEffect(() => {
    const l = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      l.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    setLenis(l);
    return () => {
      cancelAnimationFrame(raf);
      l.destroy();
    };
  }, []);
  return <LenisContext.Provider value={lenis}>{children}</LenisContext.Provider>;
};

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <BrowserRouter>
          <LenisProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/partner" element={<PartnerPage />} />
              <Route path="/driver" element={<DriverPage />} />
              <Route path="/legal" element={<LegalPage />} />
            </Routes>
            <CookieBanner />
            <Toaster position="top-center" richColors closeButton />
          </LenisProvider>
        </BrowserRouter>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
